var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-fluid p-0" },
      [
        _c("script", {
          attrs: {
            type: "module",
            src: "https://gradio.s3-us-west-2.amazonaws.com/4.31.2/gradio.js",
          },
        }),
        _vm._v(" "),
        _c("gradio-app", {
          attrs: { src: "https://fabianbg-emailui.hf.space" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-titles border-bottom" }, [
      _c("h3", [_vm._v("AI Email Data")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }